import { put, call, takeEvery, all } from 'redux-saga/effects';

import * as actions from '@actions/notes';
import {
  getPersonalNotes,
  putPersonalNotes,
  postPersonalNotes,
  getFilingNotes,
  postFilingNotes,
  putFilingNotes,
} from '@api/notes';
import types from '@constants/action-types';

export const handlePersonalNotesRequest = function* () {
  try {
    const getPersonalNotesResponse = yield call(getPersonalNotes);
    if (getPersonalNotesResponse.count) {
      yield put(actions.getPersonalNotesRequestSuccess(getPersonalNotesResponse));
    }
  } catch (error) {
    yield put(actions.getPersonalNotesRequestFailure(error));
  }
};

export const handleFilingNotesPut = function* (payload) {
  try {
    const handleFilingNotesPutResponse = yield call(putFilingNotes, payload);
    if (handleFilingNotesPutResponse.id) {
      yield put(actions.putFilingNotesRequestSuccess(handleFilingNotesPutResponse));
    } else {
      yield put(actions.putFilingNotesRequestFailure(handleFilingNotesPutResponse));
    }
  } catch (error) {
    yield put(actions.putFilingNotesRequestFailure(error));
  }
};

export const handleFilingNotesPost = function* (payload) {
  try {
    const handleFilingNotesPostResponse = yield call(postFilingNotes, payload);
    if (handleFilingNotesPostResponse.id) {
      yield put(actions.postFilingNotesRequestSuccess(handleFilingNotesPostResponse));
    } else {
      yield put(actions.postFilingNotesRequestFailure(handleFilingNotesPostResponse));
    }
  } catch (error) {
    yield put(actions.postFilingNotesRequestFailure(error));
  }
};

export const handlePersonalNotesPut = function* (payload) {
  try {
    const {
      payload: { notesId, comment },
    } = payload;
    const handlePersonalNotesPutResponse = yield call(putPersonalNotes, notesId, comment);
    if (handlePersonalNotesPutResponse.id) {
      yield put(actions.putPersonalNotesRequestSuccess(handlePersonalNotesPutResponse));
    } else {
      yield put(actions.putPersonalNotesRequestFailure(handlePersonalNotesPutResponse));
    }
  } catch (error) {
    yield put(actions.putPersonalNotesRequestFailure(error));
  }
};

export const handlePersonalNotesPost = function* (payload) {
  try {
    const {
      payload: { comment, category },
    } = payload;
    const handlePersonalNotesPostResponse = yield call(postPersonalNotes, comment, category);
    if (handlePersonalNotesPostResponse.id) {
      yield put(actions.postPersonalNotesRequestSuccess(handlePersonalNotesPostResponse));
    } else {
      yield put(actions.postPersonalNotesRequestFailure(handlePersonalNotesPostResponse));
    }
  } catch (error) {
    yield put(actions.postPersonalNotesRequestFailure(error));
  }
};

export const handleFilingNotesRequest = function* (payload) {
  try {
    const getFilingNotesResponse = yield call(getFilingNotes, payload.payload);
    yield put(actions.getFilingNotesRequestSuccess(getFilingNotesResponse));
  } catch (error) {
    yield put(actions.getFilingNotesRequestFailure(error));
  }
};

export default all([
  takeEvery(types.PERSONAL_NOTES_REQUEST, handlePersonalNotesRequest),
  takeEvery(types.PERSONAL_NOTES_STORE_PUT, handlePersonalNotesPut),
  takeEvery(types.PERSONAL_NOTES_STORE_POST, handlePersonalNotesPost),
  takeEvery(types.FILING_NOTES_REQUEST, handleFilingNotesRequest),
  takeEvery(types.FILING_NOTES_STORE_PUT, handleFilingNotesPut),
  takeEvery(types.FILING_NOTES_STORE_POST, handleFilingNotesPost),
]);
